import React from 'react'

export const HomeEnterprisePageContext = React.createContext({})

export const useHomeEnterpriseContext = () => {
  const { setOnboardingOpen, showAddToPlaylist } = React.useContext(HomeEnterprisePageContext)

  return {
    setOnboardingOpen,
    showAddToPlaylist
  }
}

export const HomeEnterprisePageProvider = ({ children, value }) => {
  return (
    <HomeEnterprisePageContext.Provider value={value}>
      {children}
    </HomeEnterprisePageContext.Provider>
  )
}
